var _rect, _rect2, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 43,
    width: 64.7246,
    height: 44.6377,
    stroke: "url(#paint0_linear_1445_37996)",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2754,
    y: 57.5078,
    width: 64.7246,
    height: 44.6377,
    fill: "url(#paint1_linear_1445_37996)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6945 87.7413L82.8853 84.916L87.8745 79.898L82.8444 74.839L85.6535 72.0137L93.4929 79.898L85.6945 87.7413ZM65.5813 87.7414L57.7827 79.8981L65.6222 72.0137L68.4314 74.839L63.4013 79.8981L68.3905 84.916L65.5813 87.7414ZM71.4713 87.743H75.4032L79.3351 72.0137H75.4615L71.4713 87.743Z",
    fill: "#3CE1CD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 51.5,
    r: 2.5,
    fill: "#3873FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 51.5,
    r: 2.5,
    fill: "#3873FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 51.5,
    r: 2.5,
    fill: "#3873FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 80C17.5 79.1716 18.1716 78.5 19 78.5C19.8284 78.5 20.5 79.1716 20.5 80H17.5ZM19 114V115.5C18.1716 115.5 17.5 114.828 17.5 114H19ZM53 112.5C53.8284 112.5 54.5 113.172 54.5 114C54.5 114.828 53.8284 115.5 53 115.5V112.5ZM20.5 80V114H17.5V80H20.5ZM19 112.5H53V115.5H19V112.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 119C55.2386 119 53 116.761 53 114C53 111.239 55.2386 109 58 109C60.7614 109 63 111.239 63 114C63 116.761 60.7614 119 58 119Z",
    stroke: "white",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 80C16.2386 80 14 77.7614 14 75C14 72.2386 16.2386 70 19 70C21.7614 70 24 72.2386 24 75C24 77.7614 21.7614 80 19 80Z",
    stroke: "white",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 60C122.5 60.8284 121.828 61.5 121 61.5C120.172 61.5 119.5 60.8284 119.5 60H122.5ZM121 26V24.5C121.828 24.5 122.5 25.1716 122.5 26H121ZM87 27.5C86.1716 27.5 85.5 26.8284 85.5 26C85.5 25.1716 86.1716 24.5 87 24.5V27.5ZM119.5 60V26H122.5V60H119.5ZM121 27.5H87V24.5H121V27.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82 21C84.7614 21 87 23.2386 87 26C87 28.7614 84.7614 31 82 31C79.2386 31 77 28.7614 77 26C77 23.2386 79.2386 21 82 21Z",
    stroke: "white",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121 60C123.761 60 126 62.2386 126 65C126 67.7614 123.761 70 121 70C118.239 70 116 67.7614 116 65C116 62.2386 118.239 60 121 60Z",
    stroke: "white",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 10.381,
    height: 10.381,
    transform: "matrix(0 -1 -1 0 125.524 119.381)",
    fill: "#3CE1CD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 10.381,
    height: 10.381,
    transform: "matrix(0 -1 -1 0 112.143 119.381)",
    fill: "#3CE1CD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 10.381,
    height: 10.381,
    transform: "matrix(0 -1 -1 0 98.762 119.381)",
    fill: "#3CE1CD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10.381,
    height: 10.381,
    transform: "matrix(0 -1 -1 0 85.3809 119.381)",
    fill: "#3CE1CD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 10.381,
    height: 10.381,
    transform: "matrix(0 1 1 0 14 21)",
    fill: "#3CE1CD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 10.381,
    height: 10.381,
    transform: "matrix(0 1 1 0 27.3809 21)",
    fill: "#3CE1CD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 10.381,
    height: 10.381,
    transform: "matrix(0 1 1 0 40.762 21)",
    fill: "#3CE1CD"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 10.381,
    height: 10.381,
    transform: "matrix(0 1 1 0 54.1431 21)",
    fill: "#3CE1CD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1445_37996",
    x1: 63.3623,
    y1: 43,
    x2: 63.3623,
    y2: 87.6377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3873FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3873FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1445_37996",
    x1: 75.6377,
    y1: 57.5078,
    x2: 75.6377,
    y2: 102.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3873FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3873FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon_11.f9d17973d09c5e12c47e64ac7383a25c.svg";
export { ForwardRef as ReactComponent };